import { Component, inject } from '@angular/core';
import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';
import { AccordionComponent } from '@shared/components/accordion/accordion.component';
import { SwitcherComponent } from '@shared/components/form-elements/switcher/switcher.component';
import { ProductsTableService } from '@b2b/features/product/components/products-table/products-table.service';
import { PRODUCT_LIST_FIELD } from '@b2b/features/product/components/products-table/products-table.types';

@Component({
  selector: 'columns-config',
  imports: [SwitcherComponent, AccordionComponent],
  templateUrl: './columns-config.component.html',
  styleUrl: './columns-config.component.scss',
})
export class ColumnsConfigComponent {
  private readonly productsTableService = inject(ProductsTableService);

  PRODUCT_LIST_FIELD = PRODUCT_LIST_FIELD;
  columns = this.productsTableService.columns;
  invoiceAmountLabel = this.productsTableService.invoiceAmountLabel;

  onCheck(event: ToggleSwitchChangeEvent, field: PRODUCT_LIST_FIELD) {
    this.productsTableService.enableColumn(field, event.checked);
  }
}
